import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../components/button.jsx";
import Loading from "../components/loading.jsx";
import post from "../functions/post.js";

const EditExercise = ({info, type, buttonOne, onSuccess, onFail}) => {

    const location = useLocation();

    const [ loading, setLoading ] = useState(false);
    const [ error, setError ] = useState("");

    const [ chosenNoun, setChosenNoun ] = useState({
        noun: "",
        kasus: ""
    });

    const changeNoun = (noun, kasus) => {

        setChosenNoun({
            noun: noun,
            kasus: kasus
        });

    };

    const onRes = (res, data) => {

        if(!res) {
            onFail();
        };

        setLoading(false);
        if (res.status === 200) {
            onSuccess(data);
        } else {
            onFail();
        };

    };

    const addQuestion = () => {

        let finalInfo = info;
        if(info.q_type === "Kasus bestimmen") {
            if (chosenNoun.noun && chosenNoun.noun !== "") {
                finalInfo = {
                    ...info,
                    question: "In welchem Kasus steht dieses Nomen?",
                    solution: chosenNoun
                }
            } else {
                setError("Bitte wähle eines der Nomen aus!");
                return;
            }
        }

        const url = location.pathname.split("/");

        const frage = url.findIndex(s => s === "frage");
        const frageID = frage >= 0 ? url[frage + 1] : null;

        setLoading(true);
        if (frageID) {
            finalInfo = {
                ...finalInfo,
                id: info.id
            }
            post("/edit/question", finalInfo, onRes, onRes);
        } else {
            post("/add/question", finalInfo, onRes, onRes);
        }

    };

    if (loading) {
        return (
            <div style={{height: "100vh", width: "100vw"}}>
                <Loading />
            </div>
        );
    };

    if (type === "Kasus bestimmen") {
        return (
            <>
                <h2>ÜBUNG ERSTELLEN</h2>

                <p>Super! Dein Satz wurde analysiert. Hier ist das Resultat und die dazügehörige Aufgabenstellung: </p>

                <p style={{marginTop: "30px"}}>Satz: </p>

                <p>{info.sentence}</p>

                <p style={{marginTop: "20px"}}>Frage/Aufgabe: </p>

                <p>{info.question}</p>

                {info.solution.length > 0 &&
                    <div>
                        {info.solution.map((e, idx) => {

                            return (
                                <div key={idx} className="flex-row" style={{justifyContent: "flex-start", cursor: "pointer"}} onClick={() => changeNoun(e.noun, e.kasus)}>
                                    <p>Nomen: {e.noun}</p>
                                    <p>Kasus: {e.kasus}</p>
                                </div>
                            );
                        })}
                    </div>
                }

                <div className="flex-row" style={{justifyContent: "flex-start", marginTop: "10px"}}><p style={{color: "var(--yellow)"}}>Ausgewählt:</p> <p style={{color: "var(--yellow)"}}>{chosenNoun.noun}</p></div>

                <div style={{marginTop: "30px"}} onClick={buttonOne}>
                    <Button className="button-blue" text="Bearbeiten" />
                </div>

                <div onClick={addQuestion}>
                    <Button className="button-yellow" text="Bestätigen" />
                </div>

                {error &&
                    <div className="start-warning">
                        <p>{error}</p>
                    </div>
                }
            </>
        );
    }

    if (type === "Grundform erkennen") {
        return (
            <>

                <h2>ÜBUNG ERSTELLEN</h2>

                <p>Super! Dein Satz wurde analysiert. Hier ist das Resultat und die dazügehörige Aufgabenstellung: </p>

                <p style={{marginTop: "30px"}}>Satz: </p>

                <p>{info.sentence}</p>

                <p style={{marginTop: "20px"}}>Frage/Aufgabe: </p>

                <p>{info.question}</p>

                <p style={{marginTop: "20px"}}>Lösung: </p>

                {info.solution.length > 0 &&
                    <div>
                        {info.solution.map((e, idx) => {

                            return (
                                <div key={idx} className="flex-row" style={{justifyContent: "flex-start"}}>
                                    <p>Verb: {e.verb}</p>
                                    <p>Grundform: {e.base}</p>
                                </div>
                            );
                        })}
                    </div>
                }

                <div style={{marginTop: "30px"}} onClick={buttonOne}>
                    <Button className="button-blue" text="Bearbeiten" />
                </div>

                <div onClick={addQuestion}>
                    <Button className="button-yellow" text="Bestätigen" />
                </div>
            </>
        );
    };

    if (type === "Verben finden" || type === "Subjekt bestimmen" || type === "Objekte finden") {

        return (
            <>

                <h2>ÜBUNG ERSTELLEN</h2>

                <p>Super! Dein Satz wurde analysiert. Hier ist das Resultat und die dazügehörige Aufgabenstellung: </p>

                <p style={{marginTop: "30px"}}>Satz: </p>

                <div 
                    dangerouslySetInnerHTML={{__html: info.sentence}}
                />

                <p style={{marginTop: "20px"}}>Frage/Aufgabe: </p>

                <p>{info.question}</p>

                <div style={{marginTop: "30px"}} onClick={buttonOne}>
                    <Button className="button-blue" text="Bearbeiten" />
                </div>

                <div onClick={addQuestion}>
                    <Button className="button-yellow" text="Bestätigen" />
                </div>
            </>
        );
    };

}; export default EditExercise;